var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"w-full h-12 px-6 text-white text-sm transition-colors duration-150 ring-1 ring-green-light bg-green-light rounded-lg focus:outline-none font-semibold",class:_vm.classStr,on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }